import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { Avatar, Typography, CssBaseline, Container } from '@material-ui/core'
import { Warning } from '@material-ui/icons'
import { makeStyles, Theme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(2),
    backgroundColor: theme.palette.grey[500]
  },
  container: {
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5)
  }
}))

const PageNotFound: React.FC<RouteComponentProps> = () => {
  const classes = useStyles({})
  return (
    <React.Fragment>
      <Container component="main" maxWidth="xs" className={classes.container}>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <Warning />
          </Avatar>
          <Typography component="h1" variant="h5">
            ページが存在しません
          </Typography>
        </div>
      </Container>
    </React.Fragment>
  )
}

export default PageNotFound
